module.exports = __webpack_public_path__ + "static/fun-time/games/page004_game0/audio//M_Think again.mp3";